import BookingsToolbar from "./BookingsToolbar";

export default BookingsToolbar;
